import { html, TemplateResult } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { IconName, IconSize } from "../../shared/icon-names.js";

export type { IconName, IconSize };

// Typed wrapper around WARP `<w-icon>` so `name` is constrained to the published
// eikons set at compile time. Lit equivalent of the React `Icon` component.
export function icon({
    name,
    size = "small",
    locale,
    class: className,
}: {
    name: IconName;
    size?: IconSize;
    locale: string;
    class?: string;
}): TemplateResult {
    return html`<w-icon name="${name}" size="${size}" locale="${locale}" class="${ifDefined(className)}"></w-icon>`;
}
